<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            景区监控
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content video-monitor">
        <div class="nav-tree">
          <el-input placeholder="搜索监控点" class="nav-tree-filter" v-model="filterText"></el-input>
          <div class="nav-tree-content">
            <el-tree
              @node-click="nodeClick"
              :data="nodes"
              node-key="id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              ref="tree"></el-tree>
          </div>
        </div>
        <div class="nav-body">
          <div class="video-border">
            <div class="video-wrapper" v-for="(item,index) in cameras" :key="index">
              <VideoMonitorControl
                class="video"
                @spread="cameraSpread"
                :cameraId="item.cameraId"
                :cameraName="item.cameraName"
                :streamUrl="item.streamUrl"
                autoplay="true"
              />
            </div>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../../apis";
import VideoMonitorControl from "./Component-VideoMonitorControl";
import dataServerApi from "../../../../../../../request/dataServerApi";
export default {
  name: "ZJEmergencyComponentVideoMonitor",
  componentName: "ZJEmergencyComponentVideoMonitor",
  components: {
    VideoMonitorControl: VideoMonitorControl
  },
  data() {
    return {
      filterText: "",
      nodes: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      cameras: [
        {
          cameraId: "",
          cameraName: "",
          streamUrl: "",
        },
        {
          cameraId: "",
          cameraName: "",
          streamUrl: "",
        },
        {
          cameraId: "",
          cameraName: "",
          streamUrl: "",
        },
        {
          cameraId: "",
          cameraName: "",
          streamUrl: "",
        },
        {
          cameraId: "",
          cameraName: "",
          streamUrl: "",
        },
        {
          cameraId: "",
          cameraName: "",
          streamUrl: ""
        }
      ],
      selectPlayerIndex: 0
    };
  },
  created() {
    this.search();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    search() {
      let that = this;
      new MyApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor"
        })
        .then(r => {
          r = r.data.Data;
          console.log(r);
          this.nodes = that.convertToTreeNodesfunction(r);
        })
        .catch(e => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error"
          });
        });
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];

        var region = {
          id: regionData.RegionId,
          label: regionData.RegionName,
          children: []
        };

        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];
          region.children.push({
            id: deviceData.DeviceId,
            label: deviceData.DeviceName,
            children: []
          });
        }
        result.push(region);
      }
      return result;
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function(data, node, self) {
      if (node.level == 2) {
        if (this.cameras && this.cameras[this.selectPlayerIndex]) {
          this.cameras[this.selectPlayerIndex].cameraId = data.id;
          this.cameras[this.selectPlayerIndex].cameraName = data.label;
           this.getStreamUrlByCode(data.id,this.selectPlayerIndex)
          this.selectPlayerIndex = (this.selectPlayerIndex + 1) % 6;
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
     onBack: function () {
      this.$emit("handlerclose");
    },
    getStreamUrlByCode(code,index) {
      let params= {"indexCode":code}
      // let params= {"indexCode":"865ac4e15d0947d7bec6349ddf380f2d"}
      dataServerApi.getstreamurl(params).then(res=>{
        console.log(res)
        if(res.code==0){
          let streamUrl = res.data.data.url;
          this.cameras[index].streamUrl =streamUrl;
          console.log("streamUrl")
          console.log(streamUrl)
          console.log(this.cameras)
        }
      })
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  }
};
</script>

<style scoped>

</style>